import { shallowRef } from 'vue'
// Other
import rayMarching00 from "@/components/works/program/other/RayMarching00.vue"

export default [
    {
      title: "レイマーチング 00",
      caption: "ビジュアル",
      img: require("@/assets/works/program/other/RayMarching00/pic99.gif"),
      detail: shallowRef(rayMarching00),
    },
  ];